import { useContext } from "react";
import { SelectedRowsContext } from "./context";

export const useSelectedRows = () => {
  const context = useContext(SelectedRowsContext);

  if (context === undefined) {
    throw new Error("SelectedContext was used outside of its Provider");
  }

  return context;
};
